module.exports = __webpack_public_path__ + "src/assets/images/volums/eco2/volum_circle6.png?6d2aeadfae6177f8fd05becf705a9740";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/eco2/volum_circle6.png
// module id = 724
// module chunks = 0